 import slide01 from '../assets/Images/slide01.jpg';
 import slide2 from '../assets/Images/slide2.jpg';
 import slide3 from '../assets/Images/slide3.jpg';
 import slide4 from '../assets/Images/slide4.jpg';
 import slide5 from '../assets/Images/slide5.jpg';
 import slide6 from '../assets/Images/slide6.jpg';
 import slide7 from '../assets/Images/slide7.jpg';
 import slide8 from '../assets/Images/slide8.jpg';
 import slide9 from '../assets/Images/slide9.jpg';
 import slide10 from '../assets/Images/slide10.jpg';

 const slides = [
  {
    title: "Kentucky Mops",
    description: "Finest quality cotton yarn to ensure maximum absorption and long life. Daily usage cleaning mop. Launderable mops with stand repeat.",
    img:slide01,
    bgColor: "#f4f4f4"
  },
  {
    title: "Flat Mops",
    description: "Flat Mops are known for hygienic, smooth and economical cleaning. Fine quality cotton yarn helps to clean dirt, dust, grease and other contaminated stuff.",
    img: slide2,
    bgColor: "#f7f7f7"
  },
   {
    title: "Holders and Frames",
    description: "Lightweight design that provides effective improvements in labor productivity. 360º swivel attachment for move in tight areas. Handle Locking Clip grips the handle strongly.",
    img:slide3,
    bgColor: "#f4f4f4"
  },
 {
    title: "Handles",
    description: "All our handles are offered in color coded grips and matching color Mop Holders to complete the set.",
    img:slide4,
    bgColor: "#f4f4f4"
  },
 {
    title: "Cleaning Clothes",
    description: "Cleaning Clothes Perfect for cleaning hundreds of surfaces. They are safe and effectively clean and brighten glass, ceramic, chrome, plastic, marble, fiberglass, stainless steel, leather, granite etc.",
    img: slide5,
    bgColor: "#f4f4f4"
  },
 {
    title: "Trolleys",
    description: "Elevate your cleaning game with Eagle International's exceptional janitorial trolleys. Meticulously crafted with precision and attention to detail.",
    img:slide6,
    bgColor: "#f4f4f4"
  },
 {
    title: "Protective Equipments",
    description: "We offer quality products for hygiene and safety to our clients.",
    img: slide7,
    bgColor: "#f4f4f4"
  },
 {
    title: "Bedding Range",
    description: "Introducing the Eagle bedsheet range, where comfort and style come together to transform your bedroom into a cozy oasis.",
    img: slide8,
    bgColor: "#f4f4f4"
  },
 {
    title: "Safety Wears",
    description: "We take pride in our commitment to protecting the workforce by designing and producing high-quality safety apparel that meets and exceeds industry standards.",
    img: slide9,
    bgColor: "#f4f4f4"
  },
 {
    title: "Mini Mops",
    description: "Fine Quality Cotton Mops in Mini style, the best choice for professional cleaning, known for economical and durable features.",
    img: slide10,
    bgColor: "#f4f4f4"
  },





];

export default slides;